import React, { useEffect } from "react";
import { Preview } from "@creatomate/preview";

import { PlainButton, classnames } from "@culturehq/components";
import { ElementSource, Story } from "chq";
import { useProfile } from "app/context";
import { errorService, Trans } from "app/utils";
import { isSubtitleText } from "./utils";
import { LANGUAGE_CODES } from "./utils/constants";

interface SubtitleTabProps {
  activeLanguageCode?: string;
  changingLanguage?: boolean;
  language: string;
  loading?: boolean;
  onLanguageChange: (subtitle: string) => void;
  preview: Preview;
  story?: Story;
}

const SubtitleTab: React.FC<SubtitleTabProps> = ({
  activeLanguageCode,
  changingLanguage,
  language,
  loading,
  onLanguageChange,
  preview,
  story
}) => {
  const { profile: { organization } } = useProfile();

  useEffect(() => {
    const putDefaultSubtitle = async () => {
      const source = preview.getSource();
      await preview.setSource({
        ...source,
        elements: source.elements.map((element: ElementSource) => {
          if (!isSubtitleText(element.name)) return element;

          const [prefix, index, ...rest] = element.name.split("-");
          const newName = `${prefix}-${index}-${language === "not-found" ? "en" : language}-${rest.join("-")}`;
          return {
            ...element,
            name: newName
          };
        })
      }, false);
    };

    if (!LANGUAGE_CODES[language]) {
      errorService.error(`Language code not found for story ${story?.id}, prompt: ${story?.question?.id}, organization: ${organization?.name}`);
      putDefaultSubtitle();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [story, organization]);

  return (
    <li role="navigation">
      <PlainButton
        className={classnames(
          { active: activeLanguageCode === language }
        )}
        disabled={changingLanguage}
        onClick={() => { onLanguageChange(language); }}
      >
        {LANGUAGE_CODES[language] || LANGUAGE_CODES.en}
        {loading && (
          <>
            {" "}
            <i><Trans>(processing)</Trans></i>
          </>
        )}
      </PlainButton>
    </li>
  );
};

export default SubtitleTab;
